export enum AutocompleteValues {
    OFF = 'off',
    ON = 'on',
    NEW_PASSWORD = 'new-password',
    CURRENT_PASSWORD = 'current-password',
    USERNAME = 'username',
    EMAIL = 'email'
}
